export default __webpack_public_path__ + "static/17-ab27df177980088fc1cf2b06b291e859.jpg";